import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ApiResultV2Vo} from '../../common/shared/api/nicolas/vo/ApiResultV2Vo.interface';
import type {TicketHistoryBuyDetailVo} from '../../common/shared/api/nicolas/vo/TicketHistoryBuyDetailVo.interface';

/**
 * 이용권 구매 내역 상세 조회
 *
 * Origin: pageNicolasApi.getTicketHistoryBuyDetail
 * API: GET /api/v1/ticket/history/buy_detail
 */
export async function getTicketHistoryBuyDetail(
  {
    seriesId,
    ticketId,
  }: {
    seriesId: number;
    ticketId: string;
  },
  options?: FetcherOptions
): Promise<ApiResultV2Vo<TicketHistoryBuyDetailVo>> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v1/ticket/history/buy_detail',
    {
      method: 'GET',
      params: {
        series_id: seriesId,
        ticket_id: ticketId,
      },
    },
    options
  );
  return response.data;
}
